import { useEffect, useReducer,useRef,useState } from "react";
import { Link } from "react-router-dom";
// import { MyContext } from "./Contextor";
// import "./style.css";

export default function SignupForm(props) {
    // const { user, setUser } = useContext(MyContext);
    const emailRef = useRef(null);
    const passwordRef = useRef(null);
    function signup(params) {
      
    }
  return (
    <form>
      <div className="form needs-validation">
        <h1 className="text-center">Créer un compte</h1>
        <form className="needs-validation dz-w-90-m dz-w-350-l dz-centered">
          <div className="dz-padding-top-bottom dz-w-100">
            <label htmlFor="validationCustomUsername" className="form-label dz-medium dz-padding-top-bottom">
              Nom d'utilisateur (adresse email)
            </label>
            <div className="input-group has-validation dz-w-90">
              <input
                ref={emailRef}
                type="email"
                className="form-control dz-padding dz-w-100 dz-round-large dz-border-0-"
                id="validationCustomUsername"
                aria-describedby="inputGroupPrepend"
                required
              ></input>
              <div className="invalid-feedback dz-small">L'adress email de votre compte.</div>
            </div>
          </div>
          <div className="dz-padding-top-bottom dz-w-100">
            <label htmlFor="validationCustomUsername" className="form-label dz-medium dz-padding-top-bottom">
              Mot de passe
            </label>
            <div className="input-group has-validation dz-w-90">
              <input
                ref={passwordRef}
                minLength={6}
                type="password"
                className="form-control dz-padding dz-w-100 dz-round-large dz-border-0-"
                id="validationCustomUsername"
                aria-describedby="inputGroupPrepend"
                required
              ></input>
              <div className="invalid-feedback dz-small">Le mot de passe de votre compte.</div>
            </div>
          </div>
          <div className="dz-padding-top-bottom dz-w-100">
            <label htmlFor="validationCustomUsername" className="form-label dz-medium dz-padding-top-bottom">
              Numéro de téléphone
            </label>
            <div className="input-group has-validation dz-w-90">
              <input
                ref={passwordRef}
                minLength={9}
                maxLength={9}
                pattern="^\d+$"
                type="tel"
                inputMode="numeric"
                className="form-control dz-padding dz-w-100 dz-round-large dz-border-0-"
                id="validationCustomUsername"
                aria-describedby="inputGroupPrepend"
                required
              ></input>
              <div className="invalid-feedback dz-small">Doit contenir exatement 9 chiffres.</div>
            </div>
          </div>
          <div className="dz-w-100 dz-padding-top-bottom">
            <button onClick={signup} className="dz-btn dz-round dz-padding dz-w-100 dz-primary dz-text-white dz-ripple dz-border-0 dz-medium" type="submit">
              S'inscrire
            </button>
          </div>
          <div className="">
            <p>
              Vous avez déjà un compte?{" "}
              <Link to="/login" className="dz-text-primary">Connectez-vous</Link>{" "}
            </p>
          </div>
        </form>
      </div>
    </form>
  );
}